import React, { useRef, useEffect, useState, useCallback  } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables";
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton'; 
import MenuItem  from "@mui/material/MenuItem";
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import FormSearchStores from "pages/forms/editOrNewFormDI/FormSearchStores";
import FormSearchStoresNimaAddresses from "pages/forms/editOrNewFormDI/FormSearchStoresNimaAddress";
import FormSearchStoresAddresses from "./FormSearchStoresAddress";
import FormSearchStoreVehicles from "./FormSearchVehicles";
import PropTypes from 'prop-types';

const initialPostalCodesToSelect = [{
    "id":0,
    "postalcode":"",
    "name":"",
    "postalcodename":"",
    "enabled":true,
    "province_id":0,
    "province_name":""
}];

const initialDocumentIdToSelect = [{
    "id": 0,
    "documentid": "",
    "tradename": ""
}];

const initialNimaToSelect = [{
    "id":0,
    "nima":""
}];

const FormCreateOrEditRelTrans = ({formForm,setFormForm,setIsLoadingErrorData,errorsForm,setErrorsForm,validateFormForm,documentTypesToSelect,roadTypesToSelect,communityToSelect,expanded,optTypeToSelect,hasbeenshared,sharedLicensePlate}) => {
    const {t,i18n} = useTranslation(['listDataForms']);
    const token = useSelector((state) => state.loginUser.token); 
    const roles = useSelector((state) => state.loginUser.roles);  
    const DEFAULTTYPEOFDOCUMENT = useSelector((state) => state.formatDIUser.default_documenttype); 
    const DEFAULTROADTYE = useSelector((state) => state.formatDIUser.default_roadtype); 
    const DEFAULTCOUNTRY = useSelector((state) => state.formatDIUser.default_country); 
    const DEFAULTCOUNTRY_NAME = useSelector((state) => state.formatDIUser.default_country_name); 
    const DEFAULTPROVINCE = useSelector((state) => state.formatDIUser.default_province); 
    const DEFAULTPROVINCE_NAME = useSelector((state) => state.formatDIUser.default_province_name); 
    const DEFAULTPOSTALCODE_ID = useSelector((state) => state.formatDIUser.default_postalcode); 
    const DEFAULTPOSTALCODE_CODE = useSelector((state) => state.formatDIUser.default_postalcode_code); 
    const DEFAULTPOSTALCODE_NAME = useSelector((state) => state.formatDIUser.default_postalcode_name); 
    const DEFAULTCOMMUNITY = useSelector((state) => state.formatDIUser.default_community); 
    const DEFAULTCOMMUNITY_NAME = useSelector((state) => state.formatDIUser.default_community_name); 
    
    const rel_trans_view_name = useSelector((state) => state.formatDIUser.rel_trans_view_name); 
    const rel_trans_view_contactname = useSelector((state) => state.formatDIUser.rel_trans_view_contactname); 
    const rel_trans_view_address = useSelector((state) => state.formatDIUser.rel_trans_view_address); 
    const rel_trans_view_phone = useSelector((state) => state.formatDIUser.rel_trans_view_phone); 
    const rel_trans_view_email = useSelector((state) => state.formatDIUser.rel_trans_view_email); 
    const rel_trans_view_nima = useSelector((state) => state.formatDIUser.rel_trans_view_nima); 
    const rel_trans_view_cnae = useSelector((state) => state.formatDIUser.rel_trans_view_cnae); 
    const rel_trans_view_inscription = useSelector((state) => state.formatDIUser.rel_trans_view_inscription); 
    const rel_trans_view_opt = useSelector((state) => state.formatDIUser.rel_trans_view_opt); 
    const rel_trans_view_licenseplate = useSelector((state) => state.formatDIUser.rel_trans_view_licenseplate); 
    const rel_trans_view_economicactivity = useSelector((state) => state.formatDIUser.rel_trans_view_economicactivity); 

    const rel_trans_handle_documnettype= useSelector((state) => state.formatDIUser.rel_trans_handle_documnettype); 
    const rel_trans_handle_documentid= useSelector((state) => state.formatDIUser.rel_trans_handle_documentid); 
    const rel_trans_handle_tradename= useSelector((state) => state.formatDIUser.rel_trans_handle_tradename); 
    const rel_trans_handle_name= useSelector((state) => state.formatDIUser.rel_trans_handle_name); 
    const rel_trans_handle_contactname= useSelector((state) => state.formatDIUser.rel_trans_handle_contactname); 
    const rel_trans_handle_address= useSelector((state) => state.formatDIUser.rel_trans_handle_address); 
    const rel_trans_handle_phone= useSelector((state) => state.formatDIUser.rel_trans_handle_phone); 
    const rel_trans_handle_email= useSelector((state) => state.formatDIUser.rel_trans_handle_email); 
    const rel_trans_handle_nima= useSelector((state) => state.formatDIUser.rel_trans_handle_nima); 
    const rel_trans_handle_cnae= useSelector((state) => state.formatDIUser.rel_trans_handle_cnae); 
    const rel_trans_handle_inscription= useSelector((state) => state.formatDIUser.rel_trans_handle_inscription); 
    const rel_trans_handle_opt= useSelector((state) => state.formatDIUser.rel_trans_handle_opt); 
    const rel_trans_handle_licenseplate= useSelector((state) => state.formatDIUser.rel_trans_handle_licenseplate); 
    const rel_trans_handle_economicactivity= useSelector((state) => state.formatDIUser.rel_trans_handle_economicactivity); 
    const [showModalSearchStores, setShowModalSearchStores] = useState(false); 
    const [showModalSearchStoresAddress, setShowModalSearchStoresAddress] = useState(false); 
    const [showModalSearchStoresNimaAddress, setShowModalSearchStoresNimaAddress] = useState(false);     
    const [showModalSearchVehicles, setShowModalSearchVehicles] = useState(false); 
    const dispatch = useDispatch(); 
    const [postalCodeRelTransToSelect,setPostalCodeRelTransToSelect]= useState(initialPostalCodesToSelect);  
    const [filteredpostalCodeRelTrans, setFilteredpostalCodeRelTrans] = useState([]); // Opciones filtradas
    const [highlightedIndexPostalCodeRelTrans, setHighlightedIndexPostalCodeRelTrans] = useState(-1); // Índice de la opción resaltada    
    const [documentIdRelTransToSelect,setDocumentIdRelTransToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredDocumentIdRelTrans, setFilteredDocumentIdRelTrans] = useState([]); // Opciones filtradas
    const [highlightedIndexDocumentIdRelTrans, setHighlightedIndexDocumentIdRelTrans] = useState(-1); // Índice de la opción resaltada 
    const [tradenameRelTransToSelect,setTradenameRelTransToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredTradenamedRelTrans, setFilteredTradenamedRelTrans] = useState([]); // Opciones filtradas
    const [highlightedIndexTradenamedRelTrans, setHighlightedIndexTradenamedRelTrans] = useState(-1); // Índice de la opción resaltada 
    const [relTransNimaToSelect,setRelTransNimaToSelect]= useState(initialNimaToSelect);  
    const [filteredRelTransNima, setFilteredRelTransNima] = useState([]); // Opciones filtradas
    const [highlightedIndexRelTransNima, setHighlightedIndexRelTransNima] = useState(-1); // Índice de la opción resaltada 
          
    // Debounce helper
    const useDebounce = (callback, delay = 300) => {
        const timeoutRef = useRef(null);
        return useCallback((...args) => {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
            callback(...args);
            }, delay);
        }, [callback, delay]);
    };

    // Dentro del componente
    const debouncedHandleSearchPostalCode= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredpostalCodeRelTrans([]);
            setHighlightedIndexPostalCodeRelTrans(-1);
        return;
        }
        const filtered = postalCodeRelTransToSelect
        .filter(postal => postal && postal.postalcode)
        .filter(postal => {
            const postalcode = postal.postalcode.toUpperCase();
            return postalcode.startsWith(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredpostalCodeRelTrans(filtered);
        setHighlightedIndexPostalCodeRelTrans(0);
    }, 300); 
    const handleSelectPostalCodeRelTrans = (postal) => {
        if (!postal) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
            ...formForm,
            rel_trans_postalcode_id: postal.id || Number(DEFAULTPOSTALCODE_ID),
            rel_trans_postalcode_code: postal.postalcode ||  DEFAULTPOSTALCODE_CODE,
            rel_trans_postalcode_name: postal.name || DEFAULTPOSTALCODE_NAME,
            rel_trans_province_id: postal.province_id || Number(DEFAULTPROVINCE),
            rel_trans_province_name: postal.province_name || DEFAULTPROVINCE_NAME
        }));
        setFilteredpostalCodeRelTrans([]);
        setHighlightedIndexPostalCodeRelTrans(-1);
    }; 
    const handleKeyDownDPostalCodeRelTrans = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredpostalCodeRelTrans.length === 0 && formForm.rel_trans_postalcode_code.trim() === "") {
            setHighlightedIndexPostalCodeRelTrans(postalCodeRelTransToSelect);
            setHighlightedIndexPostalCodeRelTrans(0);
        } else {
            setHighlightedIndexPostalCodeRelTrans((prevIndex) => {
            const nextIndex = prevIndex < filteredpostalCodeRelTrans.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
        setHighlightedIndexPostalCodeRelTrans((prevIndex) => {
            const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
            // Desplaza al elemento anterior
            scrollToElement(prevIndexValid);
            return prevIndexValid;
        });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexPostalCodeRelTrans >= 0) {
            if (highlightedIndexPostalCodeRelTrans >= 0 && highlightedIndexPostalCodeRelTrans < filteredpostalCodeRelTrans.length) {
                handleSelectPostalCodeRelTrans(filteredpostalCodeRelTrans[highlightedIndexPostalCodeRelTrans]);
            }
        } else if (event.key === "Escape") {
        const isValid = postalCodeRelTransToSelect.some((postal) => {
            if (!postal || !postal.postalcode) return false; 
            const normalizedPostalCodeId = postal.postalcode.toUpperCase().replace(/[.-]/g, "");
            const normalizedInputId = formForm.rel_trans_postalcode_code.toUpperCase();
            return normalizedPostalCodeId === normalizedInputId;
        }); 
        if (!isValid) { 
            setFormForm((formForm) => ({
                ...formForm,
                rel_trans_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
                rel_trans_postalcode_code:  DEFAULTPOSTALCODE_CODE,
                rel_trans_postalcode_name: DEFAULTPOSTALCODE_NAME,
                rel_trans_province_id: Number(DEFAULTPROVINCE),
                rel_trans_province_name: DEFAULTPROVINCE_NAME
            }));
        } 
        setFilteredpostalCodeRelTrans([]);
        setHighlightedIndexPostalCodeRelTrans(-1);
        }
    };
    // Dentro del componente
    const debouncedHandleSearchDocumentIdRel = useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredDocumentIdRelTrans([]);
            setHighlightedIndexDocumentIdRelTrans(-1);
            return;
        }
        const filtered = documentIdRelTransToSelect
            .filter(store => store && store.documentid)
            .filter(store => {
            const documentId = store.documentid.toUpperCase();
            return documentId.includes(upperValue);
            })
            .slice(0, 20); // limitar resultados
        setFilteredDocumentIdRelTrans(filtered);
        setHighlightedIndexDocumentIdRelTrans(0);
    }, 300);
    const handleSelectDocumentIdRelTrans = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
        ...formForm,
        rel_trans_documentid: store.documentid || "",
        }));
        setFilteredDocumentIdRelTrans([]);
        setHighlightedIndexDocumentIdRelTrans(-1);
    }; 
    const handleKeyDownDocumentIdRelTrans = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredDocumentIdRelTrans.length === 0 && formForm.rel_trans_documentid.trim() === "") {
            setFilteredDocumentIdRelTrans(documentIdRelTransToSelect);
            setHighlightedIndexDocumentIdRelTrans(0);
        } else {
            setHighlightedIndexDocumentIdRelTrans((prevIndex) => {
            const nextIndex = prevIndex < filteredDocumentIdRelTrans.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
        setHighlightedIndexDocumentIdRelTrans((prevIndex) => {
            const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
            // Desplaza al elemento anterior
            scrollToElement(prevIndexValid);
            return prevIndexValid;
        });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDocumentIdRelTrans >= 0) {
        if (highlightedIndexDocumentIdRelTrans >= 0 && highlightedIndexDocumentIdRelTrans < filteredDocumentIdRelTrans.length) {
            handleSelectDocumentIdRelTrans(filteredDocumentIdRelTrans[highlightedIndexDocumentIdRelTrans]);
        }
        } else if (event.key === "Escape") {
        const isValid = documentIdRelTransToSelect.some((store) => {
            if (!store || !store.documentid) return false; 
            const normalizedStoreId = store.documentid.toUpperCase().replace(/[.-]/g, "");
            const normalizedInputId = formForm.rel_trans_documentid.toUpperCase();
            return normalizedStoreId === normalizedInputId;
        }); 
        if (!isValid) {
            setFormForm((formForm) => ({
            ...formForm,
            rel_trans_documentid: "",
            }));
        } 
        setFilteredDocumentIdRelTrans([]);
        setHighlightedIndexDocumentIdRelTrans(-1);
        }
    };
    // Dentro del componente
    const debouncedHandleSearchTradenameRel= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredTradenamedRelTrans([]);
            setHighlightedIndexTradenamedRelTrans(-1);
        return;
        }
        const filtered = tradenameRelTransToSelect
        .filter(store => store && store.tradename)
        .filter(store => {
            const tradename = store.tradename.toUpperCase();
            return tradename.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredTradenamedRelTrans(filtered);
        setHighlightedIndexTradenamedRelTrans(0);
    }, 300);  
    const handleSelectTradeNameRelTrans = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
        ...formForm,
        rel_trans_tradename: store.tradename || "",
        rel_trans_documentid: store.documentid || formForm.rel_trans_documentid,
        
        }));
        setFilteredTradenamedRelTrans([]);
        setHighlightedIndexTradenamedRelTrans(-1);
    }; 
    const handleKeyDownTradenameRelTrans = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredTradenamedRelTrans.length === 0 && formForm.rel_trans_tradename.trim() === "") {
            setFilteredTradenamedRelTrans(tradenameRelTransToSelect);
            setHighlightedIndexTradenamedRelTrans(0);
        } else {
            setHighlightedIndexTradenamedRelTrans((prevIndex) => {
            const nextIndex = prevIndex < filteredTradenamedRelTrans.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
        setHighlightedIndexTradenamedRelTrans((prevIndex) => {
            const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
            // Desplaza al elemento anterior
            scrollToElement(prevIndexValid);
            return prevIndexValid;
        });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexTradenamedRelTrans >= 0) {
        if (highlightedIndexTradenamedRelTrans >= 0 && highlightedIndexTradenamedRelTrans < filteredTradenamedRelTrans.length) {
            handleSelectTradeNameRelTrans(filteredTradenamedRelTrans[highlightedIndexTradenamedRelTrans]);
        }
        } else if (event.key === "Escape") {
        const isValid = tradenameRelTransToSelect.some((store) => {
            if (!store || !store.tradename) return false; 
            const normalizedTradeName = store.tradename.toUpperCase();
            const normalizedInputTradeName = formForm.rel_trans_tradename.toUpperCase();
            return normalizedTradeName === normalizedInputTradeName;
        }); 
        if (!isValid) {
            setFormForm((formForm) => ({
            ...formForm,
            rel_trans_tradename: "",
            }));
        } 
        setFilteredTradenamedRelTrans([]);
        setHighlightedIndexTradenamedRelTrans(-1);
        }
    };

    // Dentro del componente
    const debouncedHandleSearchRelTransNima= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredRelTransNima([]);
            setHighlightedIndexRelTransNima(-1);
        return;
        }
        const filtered = relTransNimaToSelect
        .filter(nt => nt && nt.nima)
        .filter(nt => {
            const nima = nt.nima.toUpperCase();
            return nima.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredRelTransNima(filtered);
        setHighlightedIndexRelTransNima(0);
    }, 300); 
    const handleSelectRelTransNima = (nt) => {
        if (!nt) return; // Validación adicional para evitar errores
        setFormForm((formForm) => ({
        ...formForm,
        rel_trans_nima: nt.nima || ""
        }));
        setFilteredRelTransNima([]);
        setHighlightedIndexRelTransNima(-1);
    }; 
    const handleKeyDownRelTransNima = (event) => {
       if (event.key === "ArrowDown") {
            if (filteredRelTransNima.length === 0 && formForm.rel_trans_nima.trim() === "") {
                const filtered = relTransNimaToSelect.filter(nt => nt && nt.nima).slice(0, 20);
                setFilteredRelTransNima(filtered);
                setHighlightedIndexRelTransNima(0);
            } else {
                setHighlightedIndexRelTransNima((prevIndex) => {
                    const nextIndex = prevIndex < filteredRelTransNima.length - 1 ? prevIndex + 1 : prevIndex;
                    scrollToElement(nextIndex);
                    return nextIndex;
                });
            }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexRelTransNima((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexRelTransNima >= 0) {
            if (highlightedIndexRelTransNima >= 0 && highlightedIndexRelTransNima < filteredRelTransNima.length) {
                handleSelectRelTransNima(filteredRelTransNima[highlightedIndexRelTransNima]);
            }
        } else if (event.key === "Escape") {
            const isValid = relTransNimaToSelect.some((nt) => {
                if (!nt || !nt.nima) return false; 
                const normalizedPostalCodeId = nt.nima.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formForm.rel_trans_nima.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormForm((formForm) => ({
                ...formForm, 
                rel_trans_nima: ""
            }));
        } 
        setFilteredRelTransNima([]);
        setHighlightedIndexRelTransNima(-1);
        }
    };

    // Función para desplazar el contenedor
    const scrollToElement = (index) => {
        const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
        const item = dropdown?.children[index];
        if (item) {
        item.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
        });
        }
    };

    const handleBlur = useCallback((event) => {
        if (!event || !event.currentTarget) return;
        // Asegúrate de que no se cierra si haces clic en un elemento de la lista
        if (!event.currentTarget.contains(event.relatedTarget)) {
            setFilteredpostalCodeRelTrans([]);
            setHighlightedIndexPostalCodeRelTrans(-1);
            setFilteredDocumentIdRelTrans([]);
            setHighlightedIndexDocumentIdRelTrans(-1);
            setFilteredTradenamedRelTrans([]);
            setHighlightedIndexTradenamedRelTrans(-1); 
            setFilteredRelTransNima([]);
            setHighlightedIndexRelTransNima(-1);  
        }
    }, []);

    const handleChangeSelectDocumentType_Rel_Trans = (event) => {
        setFormForm(formForm => ({
            ...formForm,
            rel_trans_documnettype_id:event.target.value
        }));
    };
    const handleBlurSelectDocumentType_Rel_Trans = (e) => {
        handleChangeSelectDocumentType_Rel_Trans(e);
    };
    
    const handleChangeSelectRoadType_Rel_Trans = (event) => {
        setFormForm(formForm => ({
            ...formForm,
            rel_trans_roadtype_id : event.target.value 
        }));
    };
    const handleBlurSelectRoadType_Rel_Trans = (e) => {
        handleChangeSelectRoadType_Rel_Trans(e);
        setErrorsForm(validateFormForm());
    };
       
    const handleChangeSelectCommunity_Rel_Trans = (event) => {
        setFormForm(formForm => ({
            ...formForm,
            rel_trans_community_id : event.target.value   
        }));
    };
    const handleBlurSelectCommunity_Rel_Trans = (e) => {
        handleChangeSelectCommunity_Rel_Trans(e);
        setErrorsForm(validateFormForm());
    };

    const handleChangeDataEditForm_Rel_Trans = (e) => {
        const { name, value } = e.target;
        setFormForm(formForm => ({
          ...formForm,
          [name]: value,
        }));
    };
    const handleBlurDataEditForm_Rel_Trans = (e) => {
        handleChangeDataEditForm_Rel_Trans(e);
        setErrorsForm(validateFormForm());
    };
    
    const searchFormStore = (event) => {
        setShowModalSearchStores(true);
    };

    const searchFormStoreAddress = (event) => {
        setShowModalSearchStoresAddress(true);
    };

    const searchFormStoreNimaAddress = (event) => {
        setShowModalSearchStoresNimaAddress(true);
    };

    const searchFormVehicles = (event) => {
        setShowModalSearchVehicles(true);
    };

    const deleteDateRelTrans = (event) => {
        setFormForm(formForm => ({
          ...formForm,
            rel_trans_store_id:0,
            rel_trans_documnettype_id: Number(DEFAULTTYPEOFDOCUMENT),
            rel_trans_documentid:"",
            rel_trans_tradename: "",
            rel_trans_name: "",
            rel_trans_contactname: "",
            rel_trans_roadtype_id: Number(DEFAULTROADTYE),
            rel_trans_street: "",
            rel_trans_country_id: Number(DEFAULTCOUNTRY),
            rel_trans_country_name:DEFAULTCOUNTRY_NAME,
            rel_trans_province_id: Number(DEFAULTPROVINCE),
            rel_trans_province_name:DEFAULTPROVINCE_NAME,
            rel_trans_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
            rel_trans_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            rel_trans_postalcode_name: DEFAULTPOSTALCODE_NAME,
            rel_trans_community_id: Number(DEFAULTCOMMUNITY),
            rel_trans_community_name: DEFAULTCOMMUNITY_NAME,
            rel_trans_phone: "",
            rel_trans_email: "",
            rel_trans_nima: "",
            rel_trans_cnae: "",
            rel_trans_inscription: "",
            rel_trans_opt: 0,
            rel_trans_licenseplate: "",
            rel_trans_economicactivity:""
        }));
        setErrorsForm(validateFormForm());
        setErrorsForm(errorsForm => ({
            ...errorsForm,
             rel_trans_store_id:"",
            rel_trans_documnettype_id: "",
            rel_trans_documentid:"",
            rel_trans_tradename: "",
            rel_trans_name: "",
            rel_trans_contactname: "",
            rel_trans_roadtype_id: "",
            rel_trans_street: "",
            rel_trans_country_id: "",
            rel_trans_province_id: "",
            rel_trans_postalcode_id: "",
            rel_trans_postalcode_code:"",
            rel_trans_community_id: "",
            rel_trans_phone: "",
            rel_trans_email: "",
            rel_trans_nima: "",
            rel_trans_cnae: "",
            rel_trans_inscription: "",
            rel_trans_opt: "",
            rel_trans_licenseplate: "",
            rel_trans_economicactivity:""
        }));
    };

    const deleteDataSteetRelTrans = (event) => {
        setFormForm(formForm => ({
          ...formForm,
            rel_trans_roadtype_id: Number(DEFAULTROADTYE),
            rel_trans_street: "",
            rel_trans_country_id: Number(DEFAULTCOUNTRY),
            rel_trans_country_name:DEFAULTCOUNTRY_NAME,
            rel_trans_province_id: Number(DEFAULTPROVINCE),
            rel_trans_province_name:DEFAULTPROVINCE_NAME,
            rel_trans_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
            rel_trans_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            rel_trans_postalcode_name: DEFAULTPOSTALCODE_NAME,
            rel_trans_community_id: Number(DEFAULTCOMMUNITY),
            rel_trans_community_name: DEFAULTCOMMUNITY_NAME,
            rel_trans_nima: "", 
            rel_trans_inscription: "",
            rel_trans_opt: 0
        }));
        setErrorsForm(validateFormForm());
    };

    const deleteDataVehicleRelTrans = (event) => {
        setFormForm(formForm => ({
          ...formForm,
          rel_trans_licenseplate: ""
        }));
        setErrorsForm(validateFormForm());
    };

    useEffect(() => {
        let isMounted = true;
        const fetchExistNumberDocument = async () => {
            try {
              const getData = await helpHttp().get2(ENDPOINT,`form/getexiststorebynumberdocument/`,token,formForm.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim());
              if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
              } else if (isMounted) {
                if (getData>0 && getData!==formForm.rel_trans_store_id){
                    fetchStoreNumberDocument();
                }
              }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
 
        const fetchStoreNumberDocument = async () => {
            try {
                const getData = await helpHttp().get5(ENDPOINT,`form/getformstorebynumberdocument`,token,formForm.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim(),6);
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    if (getData!==undefined && getData!==null && getData!==""){
                        setFormForm(formForm => ({
                            ...formForm,
                            rel_trans_store_id: getData.store_id,
                            rel_trans_documnettype_id: (getData.documnettype_id===undefined 
                                                    || getData.documnettype_id===null  
                                                    || getData.documnettype_id===""
                                                    || getData.documnettype_id==="0"
                                                    || getData.documnettype_id===0)?
                                                    Number(DEFAULTTYPEOFDOCUMENT):getData.documnettype_id,
                            rel_trans_tradename: getData.tradename,
                            rel_trans_name: getData.name,
                            rel_trans_contactname: getData.contacperson,
                            rel_trans_roadtype_id: (getData.roadtype_id===undefined 
                                                    || getData.roadtype_id===null  
                                                    || getData.roadtype_id===""
                                                    || getData.roadtype_id==="0"
                                                    || getData.roadtype_id===0)?
                                                    Number(DEFAULTROADTYE):getData.roadtype_id,
                            rel_trans_street: getData.street,
                            rel_trans_country_id: (getData.country_id===undefined 
                                                    || getData.country_id===null  
                                                    || getData.country_id===""
                                                    || getData.country_id==="0"
                                                    || getData.country_id===0)?
                                                    Number(DEFAULTCOUNTRY):getData.country_id,
                            rel_trans_country_name: (getData.country_name===undefined 
                                                    || getData.country_name===null  
                                                    || getData.country_name==="" )?
                                                    DEFAULTCOUNTRY_NAME:getData.country_name,
                            rel_trans_province_id: (getData.province_id===undefined 
                                                    || getData.province_id===null  
                                                    || getData.province_id===""
                                                    || getData.province_id==="0"
                                                    || getData.province_id===0)?
                                                    Number(DEFAULTPROVINCE):getData.province_id,
                            rel_trans_province_name: (getData.province_name===undefined 
                                                    || getData.province_name===null  
                                                    || getData.province_name==="" )?
                                                    DEFAULTPROVINCE_NAME:getData.province_name, 
                            rel_trans_postalcode_id: (getData.postalcode_id===undefined 
                                                        || getData.postalcode_id===null  
                                                        || getData.postalcode_id===""
                                                        || getData.postalcode_id==="0"
                                                        || getData.postalcode_id===0)?
                                                        Number(DEFAULTPOSTALCODE_ID):getData.postalcode_id,
                            rel_trans_postalcode_code: (getData.postalcode_code===undefined 
                                                        || getData.postalcode_code===null  
                                                        || getData.postalcode_code==="" )?
                                                         DEFAULTPOSTALCODE_CODE:getData.postalcode_code,
                            rel_trans_postalcode_name:   (getData.postalcode_name===undefined 
                                                        || getData.postalcode_name===null  
                                                        || getData.postalcode_name==="" )?
                                                         DEFAULTPOSTALCODE_NAME:getData.postalcode_name,                       
                            rel_trans_community_id: (getData.community_id===undefined 
                                                        || getData.community_id===null  
                                                        || getData.community_id===""
                                                        || getData.community_id==="0"
                                                        || getData.community_id===0)?
                                                        Number(DEFAULTCOMMUNITY):getData.community_id,
                            rel_trans_community_name:   (getData.community_name===undefined 
                                                        || getData.community_name===null  
                                                        || getData.community_name==="" )?
                                                         DEFAULTCOMMUNITY_NAME:getData.community_name,  
                            rel_trans_phone: getData.phone,
                            rel_trans_email: getData.email,
                            rel_trans_nima: getData.nima_rel_trans,
                            rel_trans_cnae: getData.cnae,
                            rel_trans_inscription: getData.pygr_rel_trans,
                            rel_trans_opt: getData.opt_rel_trans,
                            rel_trans_licenseplate: getData.licenseplate,
                            rel_trans_economicactivity:getData.economicactivity
                        }));
                    }  
                }         
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel6'){
            if (formForm.rel_trans_documentid && formForm.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim()!==""){
                fetchExistNumberDocument();
            } 
        }
        return () => { isMounted = false };
     }, [t,token,dispatch,expanded,formForm.rel_trans_documentid,errorsForm.rel_trans_documentid,setIsLoadingErrorData,DEFAULTCOMMUNITY,DEFAULTCOUNTRY,DEFAULTPROVINCE,setFormForm,formForm.rel_trans_store_id,
        DEFAULTCOMMUNITY_NAME,DEFAULTCOUNTRY_NAME,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPOSTALCODE_NAME,DEFAULTPROVINCE_NAME,DEFAULTROADTYE,DEFAULTTYPEOFDOCUMENT
    ]);

    useEffect(() => {
        let isMounted = true; 
        const fetchDataDocumentIdRelTrans = async () => {
            try {
            const getData = await helpHttp().get2(ENDPOINT,`form/getlistdocumentidformdi/`,token,
                (formForm.rel_trans_documentid!==undefined && formForm.rel_trans_documentid!==null && formForm.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
            if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } else if (isMounted) {
                setDocumentIdRelTransToSelect(getData); 
            }
            } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };   
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel6'){
            if (formForm.rel_trans_documentid && formForm.rel_trans_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataDocumentIdRelTrans();
            }
        } else{
            setDocumentIdRelTransToSelect(initialDocumentIdToSelect);
        } 
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm.rel_trans_documentid,expanded]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataTradenameRelTrans = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`form/getlisttradenameformdi/`,token,
                    (formForm.rel_trans_tradename!==undefined && formForm.rel_trans_tradename!==null && formForm.rel_trans_tradename.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.rel_trans_tradename.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setTradenameRelTransToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel6'){
            if (formForm.rel_trans_tradename && formForm.rel_trans_tradename.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataTradenameRelTrans();
            }
        } else{
            setTradenameRelTransToSelect(initialDocumentIdToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm.rel_trans_tradename,expanded]);

     useEffect(() => {
        let isMounted = true; 
        const fetchDataPostalCodeAutDest = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`form/getlistpostalcodeformdi/`,token,
                    (formForm.rel_trans_postalcode_code!==undefined && formForm.rel_trans_postalcode_code!==null && formForm.rel_trans_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.rel_trans_postalcode_code.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setPostalCodeRelTransToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };  
            if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel6'){
            if (formForm.rel_trans_postalcode_code && formForm.rel_trans_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataPostalCodeAutDest();
            } 
        } else{
            setPostalCodeRelTransToSelect(initialPostalCodesToSelect);
        } 
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm.rel_trans_postalcode_code,expanded,DEFAULTPROVINCE,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPROVINCE_NAME,setFormForm]);

    useEffect(() => {
        let isMounted = true; 
        const fetchDataNimaRelTrans = async () => {
            try {
                const getData = await helpHttp().get5(ENDPOINT,`searchdcs/getlistnimas`,token,formForm.rel_trans_store_id, 
                    (formForm.rel_trans_nima!==undefined && formForm.rel_trans_nima!==null && formForm.rel_trans_nima.replace(/[.\-/\\|]/g, "").trim()!=="")?formForm.rel_trans_nima.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setRelTransNimaToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel6'){
            if (formForm.rel_trans_store_id && formForm.rel_trans_store_id!==null && formForm.rel_trans_store_id!=="" && formForm.rel_trans_store_id!=="0" && formForm.rel_trans_store_id!==0){
                fetchDataNimaRelTrans(); 
            }else{
                setRelTransNimaToSelect(initialNimaToSelect);
            }
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formForm,expanded,setFormForm,formForm.rel_trans_store_id]);
    
    return(
    (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel6') &&
        <>
            <div className="row p-2"> 
                <div className="form-group"> 
                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_DocuentType')} :</label>
                &nbsp;&nbsp;&nbsp;&nbsp; 
                <TextField autoComplete="off"
                    id="rel_trans_documnettype_id"
                    name="rel_trans_documnettype_id"
                    value={ (formForm.rel_trans_documnettype_id === undefined || formForm.rel_trans_documnettype_id ===null || formForm.rel_trans_documnettype_id ===""
                        || formForm.rel_trans_documnettype_id ==="0" || formForm.rel_trans_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT):formForm.rel_trans_documnettype_id}
                    inputProps={{ style: {width: 100,  fontSize: '18px'}, maxLength: 100 }}
                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                    variant="outlined"
                    onBlur={handleBlurSelectDocumentType_Rel_Trans}
                    onChange={handleChangeSelectDocumentType_Rel_Trans}
                    disabled={!rel_trans_handle_documnettype || hasbeenshared}
                    helperText={errorsForm.rel_trans_documnettype_id!=null && errorsForm.rel_trans_documnettype_id!==""?t(errorsForm.rel_trans_documnettype_id):""}
                    select
                    SelectProps={{
                        native: false,
                        MenuProps: { PaperProps: { sx: { maxHeight: 320, minWidth: 220, maxWidth: 'calc(100vw - 32px)', borderRadius: '14px', border: '1px solid #dbe3ff', boxShadow: '0 8px 24px rgba(45,67,130,0.18)', '& .MuiList-root': { padding: '6px' }, '& .MuiMenuItem-root': { whiteSpace: 'normal', overflowWrap: 'anywhere', fontSize: 15, fontStyle: 'normal', lineHeight: 1.45, minHeight: 44, padding: '10px 12px', borderRadius: '8px', marginBottom: '2px' }, '& .MuiMenuItem-root:hover': { backgroundColor: '#f0f4ff' }, '& .MuiMenuItem-root.Mui-selected': { backgroundColor: '#e4ecff', color: '#365bc8', fontWeight: 600 }, '& .MuiMenuItem-root.Mui-selected:hover': { backgroundColor: '#d9e5ff' } } } },
                        value: (formForm.rel_trans_documnettype_id === undefined || formForm.rel_trans_documnettype_id ===null || formForm.rel_trans_documnettype_id ===""
                            || formForm.rel_trans_documnettype_id ==="0" || formForm.rel_trans_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT): formForm.rel_trans_documnettype_id
                    }}>
                    <MenuItem key={0} value=""/>
                    {documentTypesToSelect.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                            {option.name}
                        </MenuItem>
                    ))}
                </TextField>  
                {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CIF')} :</label>
                &nbsp;&nbsp;&nbsp;&nbsp; 
                <span style={{ position: "relative" }} >
                    <TextField autoComplete="off"
                        id="rel_trans_documentid"
                        name="rel_trans_documentid"
                        value={formForm.rel_trans_documentid}
                        onChange={(e) => {
                            setFormForm(prev => ({
                            ...prev,
                            rel_trans_documentid: e.target.value.toUpperCase()
                            }));
                            debouncedHandleSearchDocumentIdRel(e.target.value);
                        }}
                        onKeyDown={handleKeyDownDocumentIdRelTrans}
                        onBlur={(event) => {
                            if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                            handleBlur();
                            }
                        }}
                        label={errorsForm.rel_trans_documentid!=null && errorsForm.rel_trans_documentid!==""?t(errorsForm.rel_trans_documentid):t('PlaceHolder_FORM_CIF')}
                        placeholder={t('PlaceHolder_FORM_CIF')}
                        variant="standard"
                        inputProps={{ style: {width: i18n.language==='es'?245:285,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        disabled={!rel_trans_handle_documentid || hasbeenshared}
                    /> 
                    {/* Desplegable dinámico */}
                    {filteredDocumentIdRelTrans.length > 0 && (
                        <div
                            className="dropdown-class"
                            style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                maxWidth: "750px",
                                overflowY: "auto",
                                width: "150%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                            }}
                            onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                        >
                            {filteredDocumentIdRelTrans.map((store, index) => (
                            <MenuItem
                                key={store.id}
                                onClick={() => handleSelectDocumentIdRelTrans(store)}
                                style={{
                                    cursor: "pointer",
                                    padding: "8px",
                                    borderBottom: "1px solid #eee",
                                    fontSize: '18px',
                                    backgroundColor:
                                    index === highlightedIndexDocumentIdRelTrans ? "#4e73df" : "transparent",
                                    color: index === highlightedIndexDocumentIdRelTrans ? "white" : "black",
                                }}
                            >
                                {store.documentid} - {store.tradename}
                            </MenuItem>
                            ))}
                        </div>
                    )}
                </span>  
                &nbsp;&nbsp;
                <IconButton  size="small"className={`deletesmall-${hasbeenshared? "noselect-button ": "select-button" }`} disabled={hasbeenshared} onClick={deleteDateRelTrans}>
                    <DeleteIcon style={{fontSize: 28}}/>
                </IconButton>
                &nbsp;&nbsp;
                {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&&
                    <IconButton  size="small" className={`edit-${hasbeenshared? "noselect-button ": "select-button" }`} disabled={hasbeenshared} onClick={searchFormStore}>
                        <SearchIcon style={{fontSize: 28}}/>
                    </IconButton>
                }
                </div>
            </div>
            <div className="row p-2"> 
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_TRADENAME')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField autoComplete="off"
                            id="rel_trans_tradename"
                            name="rel_trans_tradename"
                            value={formForm.rel_trans_tradename}
                            onChange={(e) => {
                                setFormForm(prev => ({
                                ...prev,
                                rel_trans_tradename: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchTradenameRel(e.target.value);
                            }}
                            onKeyDown={handleKeyDownTradenameRelTrans}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.rel_trans_tradename!=null && errorsForm.rel_trans_tradename!==""?t(errorsForm.rel_trans_tradename):t('PlaceHolder_FORM_TRADENAME')}
                            placeholder={t('PlaceHolder_FORM_TRADENAME')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?720:696,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            disabled={!rel_trans_handle_tradename || hasbeenshared}
                        />   
                        {/* Desplegable dinámico */}
                        {filteredTradenamedRelTrans.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                    position: "absolute",
                                    left:'0px',
                                    border: "2px solid #4e73df", // Borde azul (#4e73df)
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    maxWidth: "750px",
                                    overflowY: "auto",
                                    width: "150%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa", // Fondo gris claro
                                    zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredTradenamedRelTrans.map((store, index) => (
                                <MenuItem
                                    key={store.id}
                                    onClick={() => handleSelectTradeNameRelTrans(store)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexTradenamedRelTrans ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexTradenamedRelTrans ? "white" : "black",
                                    }}
                                >
                                    {store.tradename} - {store.documentid}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                </div>
            </div>
            {rel_trans_view_name &&
                <div className="row p-2"> 
                    <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_NAME')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField autoComplete="off"
                        id="rel_trans_name" 
                        name="rel_trans_name"
                        value={formForm.rel_trans_name}
                        inputProps={{ style: {width: i18n.language==='es'?674:719,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.rel_trans_name!=null && errorsForm.rel_trans_name!==""?t(errorsForm.rel_trans_name):t('PlaceHolder_FORM_NAME')}
                        placeholder={t('PlaceHolder_FORM_NAME')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Rel_Trans}
                        onChange={handleChangeDataEditForm_Rel_Trans}
                        disabled={!rel_trans_handle_name || hasbeenshared}
                    />
                    </div>
                </div> 
            }
            {rel_trans_view_contactname &&
                <div className="row p-2"> 
                    <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CONTACT')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField autoComplete="off"
                        id="rel_trans_contactname" 
                        name="rel_trans_contactname"
                        value={formForm.rel_trans_contactname}
                        inputProps={{ style: {width: i18n.language==='es'?657:702,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.rel_trans_contactname!=null && errorsForm.rel_trans_contactname!==""?t(errorsForm.rel_trans_contactname):t('PlaceHolder_FORM_CONTACT')}
                        placeholder={t('PlaceHolder_FORM_CONTACT')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Rel_Trans}
                        onChange={handleChangeDataEditForm_Rel_Trans}
                        disabled={!rel_trans_handle_contactname || hasbeenshared}
                    />
                    </div>
                </div> 
            }
            {rel_trans_view_address &&
                <>
                    <div className="row p-2"> 
                        <div className="form-group">
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_RoadType')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField autoComplete="off"
                            id="rel_trans_roadtype"
                            name="rel_trans_roadtype"
                            value={ (formForm.rel_trans_roadtype_id === undefined || formForm.rel_trans_roadtype_id ===null || formForm.rel_trans_roadtype_id ===""
                                || formForm.rel_trans_roadtype_id ==="0" || formForm.rel_trans_roadtype_id ===0)?"":formForm.rel_trans_roadtype_id}
                            inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            variant="outlined"
                            onBlur={handleBlurSelectRoadType_Rel_Trans}
                            onChange={handleChangeSelectRoadType_Rel_Trans}
                            disabled={!rel_trans_handle_address || hasbeenshared}
                            helperText={errorsForm.rel_trans_roadtype_id!=null && errorsForm.rel_trans_roadtype_id!==""?t(errorsForm.rel_trans_roadtype_id):""}
                            select
                            SelectProps={{
                                native: false,
                        MenuProps: { PaperProps: { sx: { maxHeight: 320, minWidth: 220, maxWidth: 'calc(100vw - 32px)', borderRadius: '14px', border: '1px solid #dbe3ff', boxShadow: '0 8px 24px rgba(45,67,130,0.18)', '& .MuiList-root': { padding: '6px' }, '& .MuiMenuItem-root': { whiteSpace: 'normal', overflowWrap: 'anywhere', fontSize: 15, fontStyle: 'normal', lineHeight: 1.45, minHeight: 44, padding: '10px 12px', borderRadius: '8px', marginBottom: '2px' }, '& .MuiMenuItem-root:hover': { backgroundColor: '#f0f4ff' }, '& .MuiMenuItem-root.Mui-selected': { backgroundColor: '#e4ecff', color: '#365bc8', fontWeight: 600 }, '& .MuiMenuItem-root.Mui-selected:hover': { backgroundColor: '#d9e5ff' } } } },
                                value: (formForm.rel_trans_roadtype_id === undefined || formForm.rel_trans_roadtype_id ===null || formForm.rel_trans_roadtype_id ===""
                                    || formForm.rel_trans_roadtype_id ==="0" || formForm.rel_trans_roadtype_id ===0)?"": formForm.rel_trans_roadtype_id
                            }}>
                            <MenuItem key={0} value=""/>
                            {roadTypesToSelect.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                    {i18n.language==="es"?option.namees:option.nameen}
                                </MenuItem>
                            ))}
                        </TextField>  
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Address')} :</label>
                        &nbsp;&nbsp;&nbsp;&nbsp; 
                        <TextField autoComplete="off"
                            id="rel_trans_street" 
                            name="rel_trans_street"
                            value={formForm.rel_trans_street}
                            inputProps={{ style: {width: i18n.language==='es'?361:374,  fontSize: '18px', }, maxLength: 250 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                            label={errorsForm.rel_trans_street!=null && errorsForm.rel_trans_street!==""?t(errorsForm.rel_trans_street):t('PlaceHolder_FORM_Address')}
                            placeholder={t('PlaceHolder_FORM_Address')}
                            variant="standard"
                            onBlur={handleBlurDataEditForm_Rel_Trans}
                            onChange={handleChangeDataEditForm_Rel_Trans}
                            disabled={!rel_trans_handle_address || hasbeenshared}
                        />
                        </div>
                        &nbsp;&nbsp;
                        <IconButton  size="small"className={`deletesmall-${hasbeenshared? "noselect-button ": "select-button" }`} disabled={hasbeenshared} onClick={deleteDataSteetRelTrans}>
                            <DeleteIcon style={{fontSize: 28}}/>
                        </IconButton>
                        &nbsp;&nbsp;
                        {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&& formForm.rel_trans_documentid!==undefined && formForm.rel_trans_documentid!=="") ?
                            <IconButton  size="small" className={`edit-${
                                (formForm.rel_trans_store_id===undefined
                                || formForm.rel_trans_store_id===""
                                || formForm.rel_trans_store_id==="0"
                                || formForm.rel_trans_store_id===0 || hasbeenshared)? "noselect-button": "select-button" }`}
                                disabled={(formForm.rel_trans_store_id===undefined
                                || formForm.rel_trans_store_id===""
                                || formForm.rel_trans_store_id==="0"
                                || formForm.rel_trans_store_id===0 || hasbeenshared)}  onClick={searchFormStoreAddress}>
                                <SearchIcon style={{fontSize: 28}}/>
                            </IconButton>:
                            <IconButton  size="small" className="edit-noselect-button" disabled>
                                <SearchIcon style={{fontSize: 28}}/>
                            </IconButton>
                        }
                    </div>
                    <div className="row p-2"> 
                        <div className="form-group">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_PostalCode')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <span style={{ position: "relative" }}>
                                <TextField autoComplete="off"
                                    id="rel_trans_postalcode_code"
                                    name="rel_trans_postalcode_code"
                                    value={formForm.rel_trans_postalcode_code}
                                    onChange={(e) => {
                                          setFormForm(prev => ({
                                            ...prev,
                                            rel_trans_postalcode_code: e.target.value.toUpperCase()
                                        }));
                                        debouncedHandleSearchPostalCode(e.target.value);
                                    }}
                                    onKeyDown={handleKeyDownDPostalCodeRelTrans}
                                    onBlur={(event) => {
                                        if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                            const inputPostalCode = formForm.rel_trans_postalcode_code.trim().toUpperCase();
                                            const matchedPostal = postalCodeRelTransToSelect.find((postal) => {
                                            const normalizedPostal = postal.postalcode?.toUpperCase() || "";
                                            return normalizedPostal === inputPostalCode;
                                            });

                                            if (matchedPostal) {
                                                setFormForm((prev) => ({
                                                    ...prev,
                                                    rel_trans_postalcode_id: matchedPostal.id || Number(DEFAULTPOSTALCODE_ID),
                                                    rel_trans_postalcode_code: matchedPostal.postalcode || DEFAULTPOSTALCODE_CODE,
                                                    rel_trans_postalcode_name: matchedPostal.name || DEFAULTPOSTALCODE_NAME,
                                                    rel_trans_province_id: matchedPostal.province_id || Number(DEFAULTPROVINCE), 
                                                    rel_trans_province_name: matchedPostal.province_name || DEFAULTPROVINCE_NAME
                                                }));
                                            } else {
                                                setFormForm((prev) => ({
                                                    ...prev,
                                                    rel_trans_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
                                                    rel_trans_postalcode_code: DEFAULTPOSTALCODE_CODE,
                                                    rel_trans_postalcode_name: DEFAULTPOSTALCODE_NAME,
                                                    rel_trans_province_id: Number(DEFAULTPROVINCE),
                                                    rel_trans_province_name: DEFAULTPROVINCE_NAME
                                                }));
                                            }
                                            setFilteredpostalCodeRelTrans([]);
                                            setHighlightedIndexPostalCodeRelTrans(-1);
                                        }
                                    }}
                                    label={errorsForm.rel_trans_postalcode_code!=null && errorsForm.rel_trans_postalcode_code!==""?t(errorsForm.rel_trans_postalcode_code):t('Text_FORM_PostalCode')}
                                    placeholder={t('Text_FORM_PostalCode')}
                                    variant="standard"
                                    inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                />  
                                {/* Desplegable dinámico */}
                                {filteredpostalCodeRelTrans.length > 0 && (
                                    <div
                                        className="dropdown-class"
                                        style={{
                                            position: "absolute",
                                            left:'0px',
                                            border: "2px solid #4e73df", // Borde azul (#4e73df)
                                            borderRadius: "4px",
                                            marginTop: "4px",
                                            maxHeight: "200px",
                                            overflowY: "auto",
                                            width: "700%", 
                                            fontSize: '18px',
                                            backgroundColor: "#f8f9fa", // Fondo gris claro
                                            zIndex: 1000, 
                                        }}
                                        onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                    >
                                        {filteredpostalCodeRelTrans.map((postal, index) => (
                                        <MenuItem
                                            key={postal.id}
                                            onClick={() => handleSelectPostalCodeRelTrans(postal)}
                                            style={{
                                                cursor: "pointer",
                                                padding: "8px",
                                                borderBottom: "1px solid #eee",
                                                fontSize: '18px',
                                                backgroundColor:
                                                index === highlightedIndexPostalCodeRelTrans ? "#4e73df" : "transparent",
                                                color: index === highlightedIndexPostalCodeRelTrans ? "white" : "black",
                                            }}
                                        >
                                            {postal.postalcode} - {postal.name} - {postal.province_name}
                                        </MenuItem>
                                        ))}
                                    </div>
                                )}
                            </span>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Locality')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField autoComplete="off"
                                id="rel_trans_postalcode_name" 
                                name="rel_trans_postalcode_name"
                                value={formForm.rel_trans_postalcode_name}
                                inputProps={{ style: {width: i18n.language==='es'?473:503,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsForm.rel_trans_postalcode_name!=null && errorsForm.rel_trans_postalcode_name!==""?t(errorsForm.rel_trans_contactname):t('Text_FORM_Locality')}
                                placeholder={t('Text_FORM_Locality')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Rel_Trans}
                                onChange={handleChangeDataEditForm_Rel_Trans}
                                disabled
                            />   
                        </div>
                    </div>
                    <div className="row p-2"> 
                        <div className="form-group">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Community')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField autoComplete="off"
                                id="rel_trans_community_id"
                                name="rel_trans_community_id"
                                value={ (formForm.rel_trans_community_id === undefined || formForm.rel_trans_community_id ===null || formForm.rel_trans_community_id ===""
                                    || formForm.rel_trans_community_id ==="0" || formForm.rel_trans_community_id ===0)?Number(DEFAULTCOMMUNITY):formForm.rel_trans_community_id}
                                inputProps={{ style: {width: i18n.language==='es'?200:200,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                variant="outlined"
                                onBlur={handleBlurSelectCommunity_Rel_Trans}
                                onChange={handleChangeSelectCommunity_Rel_Trans}
                                disabled={!rel_trans_handle_address || hasbeenshared}
                                helperText={errorsForm.rel_trans_community_id!=null  && errorsForm.rel_trans_community_id!==""?t(errorsForm.rel_trans_community_id):""}
                                select
                                SelectProps={{
                                    native: false,
                        MenuProps: { PaperProps: { sx: { maxHeight: 320, minWidth: 220, maxWidth: 'calc(100vw - 32px)', borderRadius: '14px', border: '1px solid #dbe3ff', boxShadow: '0 8px 24px rgba(45,67,130,0.18)', '& .MuiList-root': { padding: '6px' }, '& .MuiMenuItem-root': { whiteSpace: 'normal', overflowWrap: 'anywhere', fontSize: 15, fontStyle: 'normal', lineHeight: 1.45, minHeight: 44, padding: '10px 12px', borderRadius: '8px', marginBottom: '2px' }, '& .MuiMenuItem-root:hover': { backgroundColor: '#f0f4ff' }, '& .MuiMenuItem-root.Mui-selected': { backgroundColor: '#e4ecff', color: '#365bc8', fontWeight: 600 }, '& .MuiMenuItem-root.Mui-selected:hover': { backgroundColor: '#d9e5ff' } } } },
                                    value: (formForm.rel_trans_community_id === undefined || formForm.rel_trans_community_id ===null || formForm.rel_trans_community_id ===""
                                        || formForm.rel_trans_community_id ==="0" || formForm.rel_trans_community_id ===0)?Number(DEFAULTCOMMUNITY): formForm.rel_trans_community_id
                                }}>
                                {communityToSelect.map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                        {i18n.language==="es"?option.namees:option.nameen}
                                    </MenuItem>
                                ))}
                            </TextField>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Province')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField autoComplete="off"
                                id="rel_trans_province_name" 
                                name="rel_trans_province_name"
                                value={formForm.rel_trans_province_name}
                                inputProps={{ style: {width: i18n.language==='es'?300:305,  fontSize: '18px', }, maxLength: 30 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errorsForm.rel_trans_province_name!=null && errorsForm.rel_trans_province_name!==""?t(errorsForm.rel_trans_province_name):t('Text_FORM_Province')}
                                placeholder={t('Text_FORM_Province')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Rel_Trans}
                                onChange={handleChangeDataEditForm_Rel_Trans}
                                disabled
                            />
                        </div>
                    </div>
 
                     
                </>
            }    
            { (rel_trans_view_phone || rel_trans_view_email || rel_trans_view_nima) &&
                <div className="row p-2"> 
                    <div className="form-group">
                        {rel_trans_view_phone &&
                            <>
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Phone')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <TextField autoComplete="off"
                                    id="rel_trans_phone" 
                                    name="rel_trans_phone"
                                    value={formForm.rel_trans_phone}
                                    inputProps={{ style: {width: i18n.language==='es'?180:180,  fontSize: '18px', }, maxLength: 30 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                    label={errorsForm.rel_trans_phone!=null && errorsForm.rel_trans_phone!==""?t(errorsForm.rel_trans_phone):t('PlaceHolder_FORM_Phone')}
                                    placeholder={t('PlaceHolder_FORM_Phone')}
                                    variant="standard"
                                    onBlur={handleBlurDataEditForm_Rel_Trans}
                                    onChange={handleChangeDataEditForm_Rel_Trans}
                                    disabled={!rel_trans_handle_phone || hasbeenshared}
                                />
                                {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                            </>
                        }
                        {rel_trans_view_email &&
                            <>
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Email')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <TextField autoComplete="off"
                                    id="rel_trans_email" 
                                    name="rel_trans_email"
                                    value={formForm.rel_trans_email}
                                    inputProps={{ style: {width:  (!rel_trans_view_phone || !rel_trans_view_nima)?(i18n.language==='es'?380:394):(i18n.language==='es'?181:197) ,  fontSize: '18px'}, maxLength: 100 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                    label={errorsForm.rel_trans_email!=null && errorsForm.rel_trans_email!==""?t(errorsForm.rel_trans_email):t('PlaceHolder_FORM_Email')}
                                    placeholder={t('PlaceHolder_FORM_Email')}
                                    variant="standard"
                                    onBlur={handleBlurDataEditForm_Rel_Trans}
                                    onChange={handleChangeDataEditForm_Rel_Trans}
                                    disabled={!rel_trans_handle_email || hasbeenshared}
                                />
                                {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                            </>
                        }
                        {rel_trans_view_nima &&
                            <>
                                <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_NIMA')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <span style={{ position: "relative" }}>
                                    <TextField autoComplete="off"
                                        id="rel_trans_nima"
                                        name="rel_trans_nima"
                                        value={formForm.rel_trans_nima}
                                        onChange={(e) => {
                                            setFormForm(prev => ({
                                            ...prev,
                                            rel_trans_nima: e.target.value.toUpperCase()
                                            }));
                                            debouncedHandleSearchRelTransNima(e.target.value);
                                        }}
                                        onKeyDown={handleKeyDownRelTransNima}
                                        onBlur={(event) => {
                                            if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                            handleBlur();
                                            }
                                        }}
                                        label={errorsForm.rel_trans_nima!=null && errorsForm.rel_trans_nima!==""?t(errorsForm.rel_trans_nima):t('PlaceHolder_FORM_NIMA')}
                                        placeholder={t('PlaceHolder_FORM_NIMA')}
                                        variant="standard"
                                        inputProps={{ style: {width: (!rel_trans_view_phone || !rel_trans_view_email)?133:133,  fontSize: '18px'}, maxLength: 50 }}
                                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                        disabled={!rel_trans_handle_nima || hasbeenshared}
                                    />  
                                    {/* Desplegable dinámico */}
                                    {filteredRelTransNima.length > 0 && (
                                        <div
                                            className="dropdown-class"
                                            style={{
                                                position: "absolute",
                                                left:'0px',
                                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                                borderRadius: "4px",
                                                marginTop: "4px",
                                                maxHeight: "200px",
                                                maxWidth: "750px",
                                                overflowY: "auto",
                                                width: "100%",
                                                fontSize: '18px',
                                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                                zIndex: 1000,
                                            }}
                                            onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                        >
                                            {filteredRelTransNima.map((nt, index) => (
                                            <MenuItem
                                                key={nt.id}
                                                onClick={() => handleSelectRelTransNima(nt)}
                                                style={{
                                                    cursor: "pointer",
                                                    padding: "8px",
                                                    borderBottom: "1px solid #eee",
                                                    fontSize: '18px',
                                                    backgroundColor:
                                                    index === highlightedIndexRelTransNima ? "#4e73df" : "transparent",
                                                    color: index === highlightedIndexRelTransNima ? "white" : "black",
                                                }}
                                            >
                                                {nt.nima}
                                            </MenuItem>
                                            ))}
                                        </div>
                                    )}
                                </span>
                                &nbsp;&nbsp;
                                {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formForm.rel_trans_documentid!==undefined && formForm.rel_trans_documentid!=="") ?
                                    <IconButton  size="small" className={`edit-${
                                        (formForm.rel_trans_store_id===undefined
                                        || formForm.rel_trans_store_id===""
                                        || formForm.rel_trans_store_id==="0"
                                        || formForm.rel_trans_store_id===0 || hasbeenshared)? "noselect-button": "select-button" }`}
                                        disabled={(formForm.rel_trans_store_id===undefined
                                        || formForm.rel_trans_store_id===""
                                        || formForm.rel_trans_store_id==="0"
                                        || formForm.rel_trans_store_id===0 || hasbeenshared)}  onClick={searchFormStoreNimaAddress}>
                                       <SearchIcon style={{fontSize: 28}}/>
                                    </IconButton>:
                                    <IconButton  size="small" className="edit-noselect-button" disabled>
                                        <SearchIcon style={{fontSize: 28}}/>
                                    </IconButton>
                                }
                            </>
                        }
                    </div>
                </div>  
            }
            { (rel_trans_view_inscription || rel_trans_view_opt) &&
                <div className="row p-2"> 
                    <div className="form-group">
                    {rel_trans_view_inscription &&
                        <>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_INSCRIPTION')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField autoComplete="off"
                                id="rel_trans_inscription" 
                                name="rel_trans_inscription"
                                value={formForm.rel_trans_inscription}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                inputProps={{ style: {width: !rel_trans_view_opt?350:250,  fontSize: '18px'}, maxLength: 50 }}
                                label={errorsForm.rel_trans_inscription!=null && errorsForm.rel_trans_inscription!==""?t(errorsForm.rel_trans_inscription):t('PlaceHolder_FORM_INSCRIPTION')}
                                placeholder={t('PlaceHolder_FORM_INSCRIPTION')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Rel_Trans}
                                onChange={handleChangeDataEditForm_Rel_Trans}
                                disabled={!rel_trans_handle_inscription || hasbeenshared}
                            />
                            {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                        </>
                    }
                    {rel_trans_view_opt &&
                        <>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_OPT')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField autoComplete="off"
                                id="rel_trans_opt"
                                name="rel_trans_opt"
                                value={ (formForm.rel_trans_opt === undefined || formForm.rel_trans_opt ===null || formForm.rel_trans_opt ===""
                                    || formForm.rel_trans_opt ==="0" || formForm.rel_trans_opt ===0)?0:formForm.rel_trans_opt}
                                inputProps={{ style: {width: i18n.language==='es'?170:147,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                variant="outlined"
                                onBlur={handleBlurDataEditForm_Rel_Trans}
                                onChange={handleChangeDataEditForm_Rel_Trans} 
                                helperText={errorsForm.rel_trans_opt!=null?t(errorsForm.rel_trans_opt):""}
                                disabled={!rel_trans_handle_opt || hasbeenshared}
                                select
                                SelectProps={{
                                    native: false,
                        MenuProps: { PaperProps: { sx: { maxHeight: 320, minWidth: 220, maxWidth: 'calc(100vw - 32px)', borderRadius: '14px', border: '1px solid #dbe3ff', boxShadow: '0 8px 24px rgba(45,67,130,0.18)', '& .MuiList-root': { padding: '6px' }, '& .MuiMenuItem-root': { whiteSpace: 'normal', overflowWrap: 'anywhere', fontSize: 15, fontStyle: 'normal', lineHeight: 1.45, minHeight: 44, padding: '10px 12px', borderRadius: '8px', marginBottom: '2px' }, '& .MuiMenuItem-root:hover': { backgroundColor: '#f0f4ff' }, '& .MuiMenuItem-root.Mui-selected': { backgroundColor: '#e4ecff', color: '#365bc8', fontWeight: 600 }, '& .MuiMenuItem-root.Mui-selected:hover': { backgroundColor: '#d9e5ff' } } } },
                                    value: (formForm.rel_trans_opt === undefined || formForm.rel_trans_opt ===null || formForm.rel_trans_opt ===""
                                        || formForm.rel_trans_opt ==="0" || formForm.rel_trans_opt ===0)?0: formForm.rel_trans_opt
                                }}>
                                <MenuItem key={0} value=""/>
                                {optTypeToSelect.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                   {option.code} - {option.namees.substring(0,20)}
                                </MenuItem>
                                ))}
                            </TextField>   
                        </>
                    }
                    </div>
                </div> 
            }

            { (rel_trans_view_cnae || rel_trans_view_licenseplate) &&
                <div className="row p-2"> 
                    <div className="form-group">
                    {rel_trans_view_cnae &&
                        <>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_CNAE')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField autoComplete="off"
                                id="rel_trans_cnae" 
                                name="rel_trans_cnae"
                                value={formForm.rel_trans_cnae}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                inputProps={{ style: {width: !rel_trans_view_licenseplate?355:250,  fontSize: '18px'}, maxLength: 100 }}
                                label={errorsForm.rel_trans_cnae!=null && errorsForm.rel_trans_cnae!==""?t(errorsForm.rel_trans_cnae):t('PlaceHolder_FORM_CNAE')}
                                placeholder={t('PlaceHolder_FORM_CNAE')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Rel_Trans}
                                onChange={handleChangeDataEditForm_Rel_Trans}
                                disabled={!rel_trans_handle_cnae || hasbeenshared}
                            />
                            {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                        </>
                    }
                    {rel_trans_view_licenseplate &&
                        <>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Vehicles')} :</label>
                            &nbsp;&nbsp;&nbsp;&nbsp; 
                            <TextField autoComplete="off"
                                id="rel_trans_licenseplate" 
                                name="rel_trans_licenseplate"
                                value={formForm.rel_trans_licenseplate}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                inputProps={{ style: {width: !rel_trans_view_cnae?313:(i18n.language==='es'?313:324),  fontSize: '18px'}, maxLength: 100 }}
                                label={errorsForm.rel_trans_licenseplate!=null && errorsForm.rel_trans_licenseplate!==""?t(errorsForm.rel_trans_licenseplate):t('PlaceHolder_FORM_Vehicles')}
                                placeholder={t('PlaceHolder_FORM_Vehicles')}
                                variant="standard"
                                onBlur={handleBlurDataEditForm_Rel_Trans}
                                onChange={handleChangeDataEditForm_Rel_Trans}
                                disabled={!rel_trans_handle_licenseplate || sharedLicensePlate}
                            />
                            &nbsp;&nbsp;
                            <IconButton  size="small" className={`deletesmall-${hasbeenshared? "noselect-button ": "select-button" }`} disabled={hasbeenshared} onClick={deleteDataVehicleRelTrans}>
                                <DeleteIcon  />
                            </IconButton>
                            &nbsp;&nbsp;
                            {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&&
                                <IconButton  size="small" className={`edit-${
                                    (formForm.rel_trans_store_id===undefined
                                    || formForm.rel_trans_store_id===""
                                    || formForm.rel_trans_store_id==="0"
                                    || formForm.rel_trans_store_id===0 || hasbeenshared)? "noselect-button": "select-button" }`}
                                    disabled={(formForm.rel_trans_store_id===undefined
                                    || formForm.rel_trans_store_id===""
                                    || formForm.rel_trans_store_id==="0"
                                    || formForm.rel_trans_store_id===0 || hasbeenshared)}  onClick={searchFormVehicles}>
                                    <SearchIcon style={{fontSize: 28}}/>
                                </IconButton>
                            } 
                        </>
                    }
                    </div>
                </div> 
            }
            {rel_trans_view_economicactivity &&
                <div className="row p-2"> 
                    <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_FORM_Economicactivity')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField autoComplete="off"
                        id="rel_trans_economicactivity" 
                        name="rel_trans_economicactivity"
                        value={formForm.rel_trans_economicactivity}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        inputProps={{ style: {width: i18n.language==='es'?659:685,  fontSize: '18px'}, maxLength: 100 }}
                        label={errorsForm.rel_trans_economicactivity!=null && errorsForm.rel_trans_economicactivity!==""?t(errorsForm.rel_trans_economicactivity):t('PlaceHolder_FORM_Economicactivity')}
                        placeholder={t('PlaceHolder_FORM_Economicactivity')}
                        variant="standard"
                        onBlur={handleBlurDataEditForm_Rel_Trans}
                        onChange={handleChangeDataEditForm_Rel_Trans}
                        disabled={!rel_trans_handle_economicactivity || hasbeenshared}
                    />
                    </div>
                </div> 
            }
            <FormSearchStores
                showModalSearchStores={showModalSearchStores}
                setShowModalSearchStores={setShowModalSearchStores}
                selectStores={"Rel_Trans"}
                setFormForm={setFormForm}
            />
            <FormSearchStoresAddresses
                showModalSearchStoresAddress={showModalSearchStoresAddress}
                setShowModalSearchStoresAddress={setShowModalSearchStoresAddress}
                selectStores={"Rel_Trans"}
                setFormForm={setFormForm}
                titleTable={formForm.rel_trans_tradename}
                store_id={formForm.rel_trans_store_id}
                priority={6}
            />
             <FormSearchStoresNimaAddresses
                showModalSearchStoresNimaAddress={showModalSearchStoresNimaAddress}
                setShowModalSearchStoresNimaAddress={setShowModalSearchStoresNimaAddress}
                selectStores={"Rel_Trans"}
                setFormForm={setFormForm}
                titleTable={formForm.rel_trans_tradename}
                store_id={formForm.rel_trans_store_id} 
            />

            <FormSearchStoreVehicles
                showModalSearchVehicles={showModalSearchVehicles}
                setShowModalSearchVehicles={setShowModalSearchVehicles}
                selectStores={"Rel_Trans"}
                setFormForm={setFormForm}
                titleTable={formForm.rel_trans_tradename}
                store_id={formForm.rel_trans_store_id}
            />

        </> 
    )
}

FormCreateOrEditRelTrans.propTypes = {
    formForm: PropTypes.object.isRequired,
    setFormForm: PropTypes.func.isRequired,
    setIsLoadingErrorData: PropTypes.func.isRequired,
    errorsForm: PropTypes.object.isRequired,
    setErrorsForm: PropTypes.func.isRequired,
    validateFormForm: PropTypes.func.isRequired,
    documentTypesToSelect: PropTypes.array.isRequired,
    roadTypesToSelect: PropTypes.array.isRequired,
    communityToSelect: PropTypes.array.isRequired,
    optTypeToSelect: PropTypes.array.isRequired,
    hasbeenshared: PropTypes.bool.isRequired,
    sharedLicensePlate: PropTypes.bool.isRequired
  };
  
  export default FormCreateOrEditRelTrans;
